<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="dialogStatus"
    :width="'414px'"
    center
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <div class="tip-wrap">
      <h2>修改密码</h2>
      <p>密码至少6位长度， </p>
      <p>且由小写字母，大写字母，数字，和特殊符号组成</p>
    </div>

    <el-form
      ref="modifyPassDataForm"
      :model="modifyPassVal"
      :rules="modifyPassRules"
      label-position="top"
    >
      <!-- <el-form-item prop="oldPassword" label="原密码" :label-width="formLabelWidth">
        <el-input v-model.trim="modifyPassVal.oldPassword" type="password" autocomplete="off" />
      </el-form-item> -->
      <el-form-item prop="newPassword" label="请输入新密码">
        <el-input v-model.trim="modifyPassVal.newPassword" type="password" autocomplete="off" clearable />
      </el-form-item>
      <el-form-item prop="confirmPassword" label="再次输入新密码">
        <el-input v-model.trim="modifyPassVal.confirmPassword" type="password" autocomplete="off" clearable />
      </el-form-item>
      <el-form-item prop="vcode" label="请输入验证码">
        <el-input v-model.trim="modifyPassVal.vcode" type="text" autocomplete="off" class="code" clearable />
        <el-button
          type="primary"
          class="code-btn"
          :disabled="isCodeDisabled"
          :loading="isCodeLoading"
          @click="getVerificationCode"
        >
          {{ codeMsg }}
        </el-button>
        <p class="forget-tips" @click="noSMSCode">收不到短信验证码？</p>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="isVisible = false">取 消</el-button>
      <el-button type="primary" class="confirm-btn" @click="saveModifyPass">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import staticInfo from '@/helpers/staticInfo'
import { validPhone, validPassword } from '@/helpers/validate'
import { JSEncrypt } from 'jsencrypt'

export default {
  name: 'Modifypass',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateNewPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (!validPassword(value)) {
        callback(new Error('密码至少6位长度，且由小写字母、大写字母、数字和特殊符号组成'))
      } else if (this.errorKeys.indexOf('newPassword') >= 0) {
        callback(new Error(this.errorInfo['newPassword']))
        this.resetError('newPassword')
      } else {
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value || value !== this.modifyPassVal.newPassword) {
        callback(new Error('请确认密码'))
      } else if (this.errorKeys.indexOf('confirmPassword') >= 0) {
        callback(new Error(this.errorInfo['confirmPassword']))
        this.resetError('confirmPassword')
      } else {
        callback()
      }
    }

    const validateVcode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else if (!this.modifyPassVal.vcodeFlag) {
        callback(new Error('请获取验证码'))
      } else if (this.errorKeys.indexOf('vcode') >= 0) {
        callback(new Error(this.errorInfo['vcode']))
        this.resetError('vcode')
      } else {
        callback()
      }
    }

    return {
      formLabelWidth: '120px',
      isLoading: false,
      dialogStatus: '',
      modifyPassVal: {
        // oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        vcode: '',
        vcodeFlag: ''
      },
      modifyPassRules: {
        newPassword: [{ required: true, trigger: ['change'], validator: validateNewPassword }],
        confirmPassword: [{ required: true, trigger: ['change'], validator: validateConfirmPassword }],
        vcode: [{ required: true, trigger: ['change'], validator: validateVcode }]
      },
      errorKeys: [],
      errorInfo: {},
      validPhone: validPhone,
      timer: null,
      isShowCountDown: false,
      countDownNum: 60,
      isCodeLoading: false
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.isShow
      },
      set(val) {
        this.$emit('update:isShow', val)
      }
    },
    codeMsg() {
      if (this.isShowCountDown) {
        return `再次发送(${this.countDownNum})`
      } else {
        return '发送验证码'
      }
    },
    theme() {
      return this.$store.getters.theme
    },
    isCodeDisabled() {
      return this.isShowCountDown || !this.modifyPassVal.newPassword || !validPassword(this.modifyPassVal.newPassword) || this.modifyPassVal.confirmPassword !== this.modifyPassVal.newPassword
    }
  },
  watch: {
    isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)',
          target: '.model-content'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    },
    isBtnLoading(newValue) {
      if (newValue) {
        this.loadingComponent = this.$loading({
          lock: this.isMobile,
          spinner: 'blank',
          background: 'rgba(0,0,0,0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    },
    isVisible(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs['modifyPassDataForm'].clearValidate()
        })
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    noSMSCode() {
      const h = this.$createElement
      this.$msgbox({
        title: '',
        message: h('p', { style: 'text-align: justify' }, [
          h('span', null, '如果长时间没有收到验证码，您可以拨打咨询：'),
          h('br', null, ''),
          h('i', { class: 'point' }, `${staticInfo.NT.Tel_HotLine}（米其林）`),
          h('span', { class: 'point' }, '/ '),
          h('i', { class: 'point' }, `${staticInfo.TP.Tel_HotLine}（驰加)`)
          // h('br', null, ''),
          // h('i', { class: 'point', style: 'font-size: 22px' }, ' ${热线} '),
          // h('span', null, '咨询')
        ]),
        showCancelButton: false,
        center: true,
        customClass: 'dcp-message-box',
        confirmButtonClass: 'dcp-message-box-confirm-btn'
      }).then(action => {})
    },
    resetForm() {
      this.modifyPassVal = {
        // oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        vcode: '',
        vcodeFlag: ''
      }
    },
    resetError(val) {
      if (val) {
        const index = this.errorKeys.indexOf(val)
        this.errorKeys.splice(index, 1)
        delete this.errorInfo.val
      } else {
        this.errorKeys = []
        this.errorInfo = {}
      }
    },
    getVerificationCode() {
      this.isBtnLoading = true
      this.isCodeLoading = true

      this.$api.login.getVCode({
        loginBizType: this.theme === 'tp' ? 'TP' : 'NT',
        // loginBizType: 'ALL',
        mobile: this.$store.getters.accountInfo.mobile,
        businessType: 'BIZ_MODIFY_PASS'
      }).then(res => {
        this.isBtnLoading = false
        this.isCodeLoading = false
        this.modifyPassVal.vcodeFlag = res.data.vcodeFlag
        this.isShowCountDown = true

        this.timer = setInterval(() => {
          this.countDownNum--
          if (this.countDownNum <= 0) {
            clearInterval(this.timer)
            this.countDownNum = 60
            this.isShowCountDown = false
          }
        }, 1000)
      }).catch(err => {
        // 获取验证码失败
        clearInterval(this.timer)
        this.countDownNum = 60
        this.isShowCountDown = false
        this.isBtnLoading = false
        this.isCodeLoading = false

        if (err.errorInfos && err.errorInfos.length > 0) {
          this.resetError()
          err.errorInfos.forEach(item => {
            this.errorKeys.push(item.key)
            this.errorInfo[item.key] = item.errMsg
          })

          this.$refs['dataForm'].validate(valid => {
            console.log(valid)
          })
        }
      })
    },
    encryptStr(val) {
      const publicKey = process.env.VUE_APP_PUBLIC_KEY
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(publicKey)
      const result = encrypt.encrypt(val)

      // console.log(result)
      return result
    },
    saveModifyPass() {
      this.$refs.modifyPassDataForm.validate(valid => {
        if (!valid) return
        if (!this.modifyPassVal.vcodeFlag) {
          this.$message.error('请输入验证码')
          return
        }
        this.isLoading = true
        const data = { ...this.modifyPassVal }
        data.newPassword = this.encryptStr(data.newPassword)
        this.$api.login.modifyPassword(data)
          .then(res => {
            this.gtag('event', 'usr_set_pwd_success')

            this.$message.success('修改密码成功')
            this.isLoading = false
            this.isVisible = false
            // 修改store的accountInfo的modifyPassFlag

            this.$store.dispatch('user/SET_ACCOUNT_INFO', {
              modifyPassFlag: 'N'
            })
          })
          .catch(err => {
            if (err.errorInfos && err.errorInfos.length > 0) {
              this.resetError()
              err.errorInfos.forEach(item => {
                this.errorKeys.push(item.key)
                this.errorInfo[item.key] = item.errMsg
              })

              this.$refs['modifyPassDataForm'].validate(valid => {
                console.log(valid)
              })
            }
            this.isLoading = false
            // this.$message.error('保存失败')
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.forget-tips {
  position: absolute;
  bottom: -41px;
  right: 0;
  font-size: 14px;
  text-align: right;
  cursor: pointer;

  @include color_page_primary('color');
}

.tip-wrap {
  margin-bottom: 20px;

  h2 {
    font-size: 24px;
    line-height: 2;
  }

  p {
    line-height: 1.6;
  }
}

/deep/ .el-form-item__label {
  padding: 0 !important;
}

.code {
  box-sizing: border-box;
  width: 54%;
  margin-right: 6%;
}

.code-btn {
  width: 40%;

  @include btn_page_primary('color');
}

.confirm-btn {
  @include btn_page_primary('color');
}
</style>
